import x from "../mui/Textfield.js";
import * as n from "ramda";
import { useCallback as a } from "react";
import { useController as v } from "react-hook-form";
import { jsx as C } from "react/jsx-runtime";
const R = (t) => {
  const {
    enableValidation: i = !0,
    helperRemark: u,
    helperText: s,
    reserveHelperTextSpace: m = !0,
    onValueChanged: l,
    ...f
  } = t, c = i ? t.rules : {}, {
    field: e,
    fieldState: {
      error: r
    }
  } = v({
    name: t.name,
    control: t.control,
    rules: c
  }), h = a((p) => {
    e.onChange(p), l && l(e.value, !r);
  }, [r, e, l]), d = a(() => {
    e.onBlur(), l && l(e.value, !r);
  }, [r, e, l]), o = m ? " " : "";
  return /* @__PURE__ */ C(x, {
    ...f,
    error: !n.isNil(r),
    helperText: r ? s || r.message || o : u || o,
    value: n.isNotNil(e.value) ? e.value : "",
    inputRef: e.ref,
    onBlur: d,
    onChange: h
  });
};
export {
  R as default
};
//# sourceMappingURL=ApeironTextField.js.map
